module.exports = __webpack_public_path__ + "product.variant-gallery-9b4b7957.html";